import useHttpLoader from '@/shared/hooks/useHttpLoader'
import { useRef, useState } from 'react'
import notificationsApi from '../../notifications.api'
import { INotification } from '../../notifications.types'
import userAtom from '@/pages/User/user.atom'
import { useSetRecoilState } from 'recoil'

const useUserNotifications = () => {
  const { wait, loading } = useHttpLoader()
  const [notifications, setNotifications] = useState<INotification[]>([])
  const [nextNotificationPageId, setNextNotificationPageId] = useState<string | null>(null)
  const setUserState = useSetRecoilState(userAtom)
  const viewedRef = useRef<Set<INotification['id']>>(new Set())

  const updateNotifications = () => {
    wait(notificationsApi.getPersonalisedNotifications(), (resp) => {
      if (resp.status === 'success') {
        setNotifications(resp.body.items)
        setNextNotificationPageId(resp.body.nextPage)
      }
    })
  }

  const sendViewed = async () => {
    if (viewedRef.current.size === 0) return
    const isNotificationsViewed = notifications.filter((item) => !item.seen).length === viewedRef.current.size
    setUserState((prev) => ({ ...prev, isNotificationsViewed }))
    await notificationsApi.setNotificationViewed([...viewedRef.current])
    viewedRef.current = new Set()
  }

  const loadNotifications = async () => {
    if (!nextNotificationPageId) return

    const resp = await notificationsApi.getPersonalisedNotifications({ pageToken: nextNotificationPageId })
    if (resp.status === 'success') {
      setNotifications((prev) => [...prev, ...resp.body.items])
      setNextNotificationPageId(resp.body.nextPage)
    }
  }

  return {
    notifications,
    updateNotifications,
    sendViewed,
    loadNotifications,
    viewedRef,
    notificationsLoading: loading,
    nextNotificationPageId,
  }
}

export default useUserNotifications
